import React from 'react';

/**
 * Decorative simulation-style backgrounds (CFD streamlines, isolines, mesh).
 * Purely presentational SVG layers — pointer-events: none.
 */
const SimulationBg = ({ variant = 'streamlines', className = '', opacity = 0.55 }) => {
  if (variant === 'streamlines') {
    return (
      <svg
        aria-hidden="true"
        className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
        viewBox="0 0 1440 700"
        preserveAspectRatio="none"
        style={{ opacity }}
      >
        <defs>
          <linearGradient id="sl-a" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#4A8FD1" stopOpacity="0" />
            <stop offset="35%" stopColor="#4A8FD1" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#4BADC8" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="sl-b" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#4BADC8" stopOpacity="0" />
            <stop offset="50%" stopColor="#4BADC8" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#E4A135" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="sl-c" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#E4A135" stopOpacity="0" />
            <stop offset="55%" stopColor="#E4A135" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#D95871" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="sl-d" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#4CB88A" stopOpacity="0" />
            <stop offset="50%" stopColor="#4CB88A" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#4A8FD1" stopOpacity="0" />
          </linearGradient>
        </defs>

        <g fill="none" strokeWidth="1.2">
          <path d="M -50 120 C 250 60, 520 200, 820 140 S 1200 60, 1500 160" stroke="url(#sl-a)" />
          <path d="M -50 200 C 280 140, 560 280, 860 220 S 1220 140, 1500 240" stroke="url(#sl-b)" />
          <path d="M -50 300 C 260 240, 540 380, 840 320 S 1200 240, 1500 340" stroke="url(#sl-a)" />
          <path d="M -50 390 C 300 330, 580 470, 880 410 S 1240 330, 1500 430" stroke="url(#sl-c)" />
          <path d="M -50 480 C 240 420, 520 560, 820 500 S 1180 420, 1500 520" stroke="url(#sl-d)" />
          <path d="M -50 580 C 290 520, 570 660, 870 600 S 1230 520, 1500 620" stroke="url(#sl-b)" />
        </g>

        {/* Vector arrow heads (sparse) */}
        <g fill="#4A8FD1" opacity="0.5">
          <polygon points="820,140 810,134 810,146" />
          <polygon points="860,220 850,214 850,226" />
        </g>
        <g fill="#E4A135" opacity="0.55">
          <polygon points="880,410 870,404 870,416" />
        </g>
        <g fill="#4CB88A" opacity="0.5">
          <polygon points="820,500 810,494 810,506" />
        </g>
      </svg>
    );
  }

  if (variant === 'isolines') {
    return (
      <svg
        aria-hidden="true"
        className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
        viewBox="0 0 1440 600"
        preserveAspectRatio="none"
        style={{ opacity }}
      >
        <g fill="none" stroke="#4A8FD1" strokeOpacity="0.22" strokeWidth="1">
          {Array.from({ length: 9 }).map((_, i) => (
            <ellipse
              key={i}
              cx="1100"
              cy="180"
              rx={80 + i * 60}
              ry={50 + i * 34}
              transform="rotate(-18 1100 180)"
            />
          ))}
        </g>
        <g fill="none" stroke="#E4A135" strokeOpacity="0.22" strokeWidth="1">
          {Array.from({ length: 7 }).map((_, i) => (
            <ellipse
              key={i}
              cx="300"
              cy="450"
              rx={60 + i * 50}
              ry={40 + i * 28}
              transform="rotate(22 300 450)"
            />
          ))}
        </g>
      </svg>
    );
  }

  return null;
};

export default SimulationBg;
